import React from 'react';

import { PinnedRoot, Root, TitleText } from './SectionHead.styles';

export type SectionHeadProps = {
  title: string;
  /** i18n interpolation values for the title (e.g. the active brand name). */
  placeholders?: Record<string, string | number>;
  /** Tighten the top margin for the first header under the topbar. */
  first?: boolean;
  /** Optional right-aligned control (e.g. the global time-range selector). */
  right?: React.ReactNode;
  /** Pin the header under the layout top bar; once pinned it morphs into a
   *  floating pill (solid surface, rounded corners, soft shadow). Opt-in. */
  sticky?: boolean;
  /** Drop the title on a phone, so the controls get the whole row (one clean line). Opt-in. */
  hideTitleOnMobile?: boolean;
};

/** A dashboard section header: the only vertical rhythm between section blocks.
 *  When `sticky`, it pins under the layout top bar and lifts into a floating pill
 *  as the page scrolls beneath it (PinnedBar). */
export const SectionHead = ({
  title,
  placeholders,
  first = false,
  right,
  sticky = false,
  hideTitleOnMobile = false,
}: SectionHeadProps): React.ReactElement => {
  const content = (
    <>
      <TitleText text={title} placeholders={placeholders} tag="span" $hideOnMobile={hideTitleOnMobile} />
      {right}
    </>
  );
  return sticky ? <PinnedRoot $first={first}>{content}</PinnedRoot> : <Root $first={first}>{content}</Root>;
};

export default SectionHead;
